module.exports = __webpack_public_path__ + "static/img/pa.b7f19475.png";